export function Price({ value, suffix = "", className = "", testId }) {
  if (value == null) return null;
  return (
    <span className={className} data-testid={testId}>
      <span>£{Number(value).toLocaleString("en-GB", Number.isInteger(Number(value)) ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
      {suffix && <span className="text-muted-foreground text-sm font-normal ml-0.5">{suffix}</span>}
    </span>
  );
}
